import axios from "axios";
import {Storage} from "@/Services/Storage";

export default {
    name: 'payment-methods',
    state: {
        kazangDetails : null,
        paymentMethods : [],
    },
    getters: {
        getPaymentMethods : (state) => state.paymentMethods,
        getKazangDetails:(state)=> state.kazangDetails
    },
    mutations: {
        setPaymentMethods : async (state , data) => {
            if (data){
                await Storage.setPaymentMethods(data);
            }else {
                data = await Storage.getPaymentMethods();
            }
            state.paymentMethods = data
        },
        setKazangDetails:(state , data)=> state.kazangDetails = data
    },
    actions: {
        getAllPaymentMethods : async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            return axios.get(franchiseTomcatApi + `payment_options/${storeDB}/getAll`)
                .then(({data}) => {
                    context.commit(`setPaymentMethods`,data)
                    return data;
                }).catch((err) => errorHandler.tomcatError(err))
        },
        updatePaymentMethod: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let id = payload.id; // Extract the id from the payload
            // Remove the id from the payload to exclude it from the POST request body
            const { id: _, ...filteredPayload } = payload;

            // Add storeDB to the filtered payload
            filteredPayload.db = storeDB;

            return axios.post(`${DeliveryNote}api/payment_options/${id}`, filteredPayload)

                .catch((err) => errorHandler.tomcatError(err));
        },

        createPaymentMethod : async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            payload.user = user.Username;
            return axios.post(franchiseTomcatApi + `payment_options/${storeDB}`,payload)
                .catch((err) => errorHandler.tomcatError(err))
        },

        editPaymentMethod : async (context, data) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.put(franchiseTomcatApi + `payment_options/${storeDB}/${data.id}`, data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        deactivatePaymentMethod : async (context, data) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.put(franchiseTomcatApi + `payment_options/${storeDB}/deactivate`, data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        /**
         * Fetch Kazang details for the current store
         * @param context
         * @returns {Promise<void>}
         */
        getKazangDetails : async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            return axios.get(subscriptionTomcatApi + `customerUpdate/getKazangDetails/${storeDB}`)
                .then(({data})=>context.commit(`setKazangDetails`,data))
                // .catch((err) => errorHandler.tomcatError(err))
        },
        /**
         * Update Kazang username and password for the current store
         * Uses global franchiseTomcatApi and injects storeDB into payload
         * @param context
         * @param payload {{username: string, password: string, channel?: string, id?: string|number, request_reference?: number}}
         * @returns {Promise<any>}
         */
        updateKazangDetails: async (context, payload) => {
            const storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            const body = {
                ...payload,
                storeDB: storeDB,
            };
            return axios.post(franchiseTomcatApi + `SetKazangUser/${storeDB}`, body)
                .then(({data}) => {
                    // Merge and persist into state for immediate UI feedback
                    const merged = { ...(context.state.kazangDetails || {}), ...payload };
                    context.commit('setKazangDetails', merged);
                    return data;
                })
                .catch((err) => errorHandler.tomcatError(err));
        },


    }
}
